import { UseFormState } from '@/hooks/useForm/interfaces';

const courseContactFormKeysOrder = [
  'Kurs',
  'Kurslink',
  'Thema',
  'firstName',
  'lastName',
  'mail',
  'Telefon',
  'Nachricht',
];

type InputData = {
  categoryTitle: string;
  courseTitle?: string;
  link: string;
} & UseFormState;

export const createCourseContactSubmitFormData = ({
  courseTitle,
  link,
  categoryTitle,
  firstName,
  lastName,
  email,
  phone,
  message,
}: InputData) => {
  return {
    Kurs: courseTitle,
    Link: link,
    Thema: categoryTitle,
    firstName,
    lastName,
    mail: email,
    Telefon: phone,
    Nachricht: message,

    keysOrder: courseContactFormKeysOrder,
  } as const;
};
